import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { AutoFocusInside } from 'react-focus-lock';
import Box from 'components/Box';
import Heading from 'components/Heading';
import Text from 'components/Text';
import PageSection from 'components/PageSection';
import ThemedBox from 'components/ThemedBox';
import ToolbarButton from 'components/ToolbarButton';
import Modal from 'components/Modal';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ExampleDescription(_ref) {
  var titleKey = _ref.titleKey,
    descriptionKey = _ref.descriptionKey;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(Box, {
    mb: "s",
    children: [/*#__PURE__*/_jsx(Heading, {
      as: "h2",
      children: t(titleKey)
    }), /*#__PURE__*/_jsx(Text, {
      dimmed: true,
      children: /*#__PURE__*/_jsx(Trans, {
        t: t,
        i18nKey: descriptionKey
      })
    })]
  });
}
export function MainThumbnailPreviewModalWrapper(_ref2) {
  var id = _ref2.id,
    pageSections = _ref2.pageSections,
    buttonText = _ref2.buttonText,
    children = _ref2.children,
    onClose = _ref2.onClose;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_jsx(Modal, {
    id: id,
    layout: "fullscreen",
    "aria-label": t('actions_review_cover_image'),
    onRequestClose: onClose,
    children: /*#__PURE__*/_jsxs(ThemedBox, {
      name: "page",
      height: "100%",
      overflow: "auto",
      children: [/*#__PURE__*/_jsx(ToolbarButton, {
        position: "absolute",
        top: "xs",
        right: "xs",
        icon: "x",
        title: buttonText || t('actions_close'),
        onClick: onClose
      }), /*#__PURE__*/_jsx(PageSection, {
        children: /*#__PURE__*/_jsx(AutoFocusInside, {
          children: children
        })
      }), pageSections]
    })
  });
}